import { Component, OnInit, signal } from "@angular/core";
import {
    faInstagramSquare,
    faLinkedin,
    faTwitterSquare,
    faXTwitter,
    faYoutubeSquare
} from "@fortawesome/free-brands-svg-icons";
import { AnalyticsService } from "app/services/analytics/analytics.service";
import { ProjectService } from "app/services/project/project.service";
import { Project } from "app/shared/models/project.interface";
import moment from "app/util/dayjs";
@Component({
    selector: "footer",
    templateUrl: "./footer.component.html",
    styleUrls: ["./footer.component.scss"],
    standalone: false
})
export class FooterComponent implements OnInit {
    faTwitterSquare = faTwitterSquare;
    faLinkedin = faLinkedin;
    faYoutubeSquare = faYoutubeSquare;
    faXTwitter = faXTwitter;
    faInstagram = faInstagramSquare;
    readonly project = signal<Project | null>(null);
    isLegalTermsEnabled: boolean;
    agno = moment().format("YYYY");

    readonly legalTermsPrivacyQuery = { type: "privacidad" };
    readonly legalTermsConditionsQuery = { type: "condiciones" };

    /**
     * Constructor
     */
    constructor(
        private analyticsSvc: AnalyticsService,
        private projectSvc: ProjectService
    ) {}

    ngOnInit() {
        this.analyticsSvc.init();
        this.isLegalTermsEnabled = localStorage.getItem("isLegalTermsEnabled") === "true" ? true : false;

        this.projectSvc.getProjectConfig().subscribe(
            (data) => {
                this.project.set(data);
                if (data.id == 9) {
                    this.isLegalTermsEnabled = false;
                }
            },
            (err) => {}
        );
    }
}
